const UPDATE_PROMO = 'UPDATE_PROMO';
const UPDATE_PROMO_BG_SETTINGS = 'UPDATE_PROMO_BG_SETTINGS';
const UPDATE_PROMO_CONTENT_BG_SETTINGS = 'UPDATE_PROMO_CONTENT_BG_SETTINGS';

const initState = {
    promoOnlineStatus: 0,
    defaultTextBoxContent: '',
    defaultBg: {},
    defaultContentBg: {},
    defaultTextColor: '',
    defaultOptionColor: '',
    defaultBtnBgColor: '',
    defaultBtnTextColor: '',
    defaultBtnText: '',
    displayCoverBtn: 0,
    coverBlockBgColor: '',
    title: ''
};

export default function promoSettings(state = initState, action) {
    switch (action.type) {
        case UPDATE_PROMO: {
            const { data } = action.payload;
            return { ...state, ...data };
        }
        case UPDATE_PROMO_BG_SETTINGS: {
            const { settings } = action.payload;
            return {
                ...state,
                defaultBg: { ...state.defaultBg, ...settings }
            };
        }
        case UPDATE_PROMO_CONTENT_BG_SETTINGS: {
            const { settings } = action.payload;
            return {
                ...state,
                defaultContentBg: { ...state.defaultContentBg, ...settings }
            };
        }
        default:
            return state;
    }
}

export function updatePromo(data) {
    return {
        type: UPDATE_PROMO,
        payload: {
            data
        }
    };
}

export function updatePromoBg(settings) {
    return {
        type: UPDATE_PROMO_BG_SETTINGS,
        payload: {
            settings
        }
    };
}

export function updatePromoContentBg(settings) {
    return {
        type: UPDATE_PROMO_CONTENT_BG_SETTINGS,
        payload: {
            settings
        }
    };
}
